export class TicketResumeCommand {
    ticketId: string;
    resumedBy: string;
    resumedByEmail: string;
    comments: string;

 constructor(params: {
    ticketId: string;
    resumedBy: string;
    resumedByEmail: string;
    comments: string;
  }) {
    this.ticketId = params.ticketId;
    this.resumedBy = params.resumedBy;
    this.resumedByEmail = params.resumedByEmail;
    this.comments = params.comments;
  }
}
